import { render, staticRenderFns } from "./survey-form.vue?vue&type=template&id=3bbc01ec&scoped=true&lang=pug"
import script from "./survey-form.vue?vue&type=script&lang=js"
export * from "./survey-form.vue?vue&type=script&lang=js"
import style0 from "./survey-form.vue?vue&type=style&index=0&id=3bbc01ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc01ec",
  null
  
)

export default component.exports